import { Box, Tab, Tabs, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import useAuth from 'hooks/useAuth';
import useUser from 'hooks/useUser';
import { FC, ReactElement, useState } from 'react';
import { useIntl } from 'react-intl';
import MainCard from 'ui-component/cards/MainCard';
import FormsTable from './FormsTable';
import TemplatesTable from './TemplatesTable';

const useStyles = makeStyles((theme: Theme) => ({
  tabs: {
    minHeight: 'auto',
    '& button': {
      minWidth: '100px',
      padding: '24px'
    },
    '& a': {
      minHeight: 'auto',
      minWidth: '10px',
      padding: '12px 8px',
      marginRight: '18px',
      color: theme.palette.grey[600]
    },
    '& a.Mui-selected': {
      color: theme.palette.primary.main
    }
  }
}));

interface TabPanelProps {
  children: ReactElement;
  value: number;
  index: number;
}

const TabPanel: FC<TabPanelProps> = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`}>
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const FormBuilderTabs = () => {
  const { userId } = useAuth();

  const { user } = useUser(userId);

  const classes = useStyles();
  const [value, setValue] = useState(0);
  const intl = useIntl();
  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };

  return (
    <MainCard content={false}>
      <Tabs
        value={value}
        indicatorColor="primary"
        onChange={handleChange}
        className={classes.tabs}
        aria-label="simple tabs example"
        variant="fullWidth"
      >
        {['peacefulwellbeing.noustalk.com', 'localhost', 'mindcure.mirror.noustalk.com'].includes(window.location.hostname) && (
          <Tab label={intl.formatMessage({ defaultMessage: 'Forms' })} />
        )}
        {['peacefulwellbeing.noustalk.com', 'localhost', 'mindcure.mirror.noustalk.com'].includes(window.location.hostname) && (
          <Tab label={intl.formatMessage({ defaultMessage: 'Templates' })} />
        )}
      </Tabs>

      {['peacefulwellbeing.noustalk.com', 'localhost', 'mindcure.mirror.noustalk.com'].includes(window.location.hostname) && (
        <TabPanel value={value} index={0}>
          <FormsTable />
        </TabPanel>
      )}
      {['peacefulwellbeing.noustalk.com', 'localhost', 'mindcure.mirror.noustalk.com'].includes(window.location.hostname) && (
        <TabPanel value={value} index={1}>
          <TemplatesTable />
        </TabPanel>
      )}
    </MainCard>
  );
};

export default FormBuilderTabs;
